import React from 'react';
import classnames from 'classnames';
import styles from './Tabs.module.scss';
import { Dispatch } from 'redux';
import { GetState } from '../../../Common/store/rootReducer';

interface TabProps {
    label: string;
    index: number;
    handleClick: (
        activeTabIndex: number,
    ) => (dispatch: Dispatch, getState: GetState) => void;
    isActiveTab: boolean;
}

const Tab: React.FC<TabProps> = ({
    label,
    index,
    handleClick,
    isActiveTab,
}) => {
    return (
        <div
            id={classnames(
                { 'tabs-tab': !isActiveTab },
                { 'tabs-tab-active': isActiveTab },
            )}
            className={classnames(styles.Tab, {
                [styles.activeTab]: isActiveTab,
            })}
            onClick={() => handleClick(index)}
        >
            {label}
        </div>
    );
};

export default Tab;
